import React from "react";
import { CircularProgress } from "@axtria/design-system-react";
import "./Loader.scss";

interface LoaderProps {
  message?: string;
}

/**
 * Loader component.
 *
 * @param props The props for the component.
 * @returns The rendered JSX element.
 */
const Loader: React.FC<LoaderProps> = ({ message }) => {
  // Return the loader component
  return (
    <div className="hqi-loader">
      <p>{message}</p>
      {/* Display the circular progress indicator */}
      <CircularProgress />
    </div>
  );
};

export default Loader
